import { render, staticRenderFns } from "./videoUpload.vue?vue&type=template&id=218b6ec4&scoped=true&"
import script from "./videoUpload.vue?vue&type=script&lang=js&"
export * from "./videoUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218b6ec4",
  null
  
)

export default component.exports